<template>
  <div id="app-container" class="app-container-box">
    <div class="message-detail-box">
      <div class="detail-title">
        <span>{{
          msgDetailInfo.msg_type == 1
            ? "打卡提醒"
            : msgDetailInfo.msg_type == 2
            ? "审核驳回提醒"
            : "同步驳回提醒"
        }}</span
        ><span class="detail-time">{{ msgDetailInfo.create_time_fmt }}</span>
      </div>
      <div class="detail-content">
        {{ msgDetailInfo.content }}
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import req from "@/js/req";
import User from "@/js/user";
import { useRouter } from "vue-router";

const router = useRouter();
const msgDetailInfo = ref({});

onMounted(() => {
  const query = router.currentRoute.value.query;
  getMessageDetail(query.mid);
});

const getMessageDetail = async (mid) => {
  const p = {
    msg_record_id: mid,
    ...User.getUTP(),
  };
  let data = await req.get(req.path.get_message_detail, p);
  msgDetailInfo.value = data;
};
</script>
<style lang="scss" scoped>
.app-container-box {
  padding: 16px;

  .message-detail-box {
    padding: 32px;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
    .detail-title {
      font-size: 28px;
      color: var(--c-text-color-black-10);
      font-weight: bold;
    }
    .detail-time {
      font-size: 22px;
      color: var(--c-text-color-gray-4);
      margin-left: 10px;
      font-weight: normal;
    }
    .detail-content {
      margin-top: 8px;
      font-size: 32px;
      color: var(--c-text-color-gray-10);
      word-break: break-all;
    }
  }
}
</style>
